import { DEFAULT_TELEPHONE_CODE } from "../../shared/types";
import { RegistrationModel } from "../types";

export const defaults: RegistrationModel = {
  admin: {
    gender: "",
    firstName: "",
    lastName: "",
    mobile: {
      code: DEFAULT_TELEPHONE_CODE,
      number: "",
    },
    emailBusiness: "",
  },
  password: "",
  acceptTermsAndConditions: false,
};
